import apiClient from "./apiClient";
const resource = "/reservation-managements";
const listCheckin = "/list-checkin";
const listInhouse = "/list-inhouse";
const listCheckout = "/list-checkout";
const roomSold = "/room-sold";


export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },
  async getListCheckin(params = {}) {
    return apiClient.get(`${listCheckin}`, { params });
  },
  async getListInhouse(params = {}) {
    return apiClient.get(`${listInhouse}`, { params });
  },
  async getListCheckout(params = {}) {
    return apiClient.get(`${listCheckout}`, { params });
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async checkOut(uuid) {
    return apiClient.put(`${resource}/${uuid}/checkout`, uuid);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(uuid, data) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
  async getRoomSold(params = {}) {
    return apiClient.get(`${roomSold}`, { params });
  },
};

